<template>
	<v-header title="联系我们" :headerLeftStatus="true" />
	<div class="sysMain">
		<div>
			<img :src="view.server+'Files/Img/contactus.jpg'" style="width:100%;height:150px" />
			<!-- <img :src="require('../../static/wwwroot/Images/contactus.jpg')" style="width:100%;height:150px" /> -->
		</div>
		<List header="">
			<ListItem >
				<div  style="text-align: center;width: 100%; font-weight: bold;">{{view.title}}</div>
			</ListItem>
			<ListItem>
				<div class="organizeInfo_Left">
					<Icon type="ios-call" size="20" color="rgba(55, 206, 55)" />联系电话：
				</div>
				<div class="organizeInfo_Right"><a :href="'tel:'+view.tel">
						<Text>{{view.tel}}</Text></a></div>
			</ListItem>
			<ListItem>
				<div class="organizeInfo_Left">
					<Icon type="ios-map" size="20" color="rgba(55, 206, 55)" />位置地址：
				</div>
				<div class="organizeInfo_Right"><Text copyable>{{view.address}}</Text></div>
			</ListItem>
			<ListItem>
				<div id="container"></div>
			</ListItem>
		</List>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	import {
		getToken
	} from '@/utils/auth'

	import AMapLoader from '@amap/amap-jsapi-loader';
	export default {
		name: 'contactus',
		data() {
			return {
				view: {
					server: process.env.VUE_APP_Server,
					title: "",
					tel: "",
					address: "",
				}
			};
		},
		created() {
			var token = getToken();
			if (token) {
				this.view.title = token.viewTitle;
				this.view.tel = token.viewTel;
				this.view.address = token.viewAddress;
			}
		},
		components: {
			"v-header": header
		}
	}
</script>

<style lang="less" scoped>
	
	.organizeInfo_Left {
		width: 100px;
		text-align: right;
	}

	.organizeInfo_Right {
		width: 70%;
	}

	#container {
		padding: 0px;
		margin: 0px;
		width: 100%;
		height: 300px;
	}
</style>
